import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {AngularFireFunctions} from '@angular/fire/compat/functions';

@Injectable({
  providedIn: 'root'
})
export class CieloService {

  constructor (
    private db: AngularFirestore,
    private ff: AngularFireFunctions,
    private _http: HttpClient
  ) { }

  callCielo () {

    const cardAuthorize: any = {
      "MerchantOrderId": "GXi7ObZKLwryC3hQYbmw",
      "Payment":
      {
        "Capture": true,
        "Type": "CreditCard",
        "Amount": 100000,
        "Installments": 1,
        "SoftDescriptor": "SoftDescriptor",
        "CreditCard":
        {
          "CardNumber": "0000000000000001",
          "Holder": "Abelardo Barbosa",
          "ExpirationDate": "10/2030",
          "SecurityCode": "321",
          "Brand": "Master"
        }
      }
    }

    const callCielo = this.ff.httpsCallable('callCielo');
    return callCielo({'cardAuthorize': JSON.stringify(cardAuthorize)})

  }

  async callCieloPIX (cardAuthorize) {

    const callCieloPIX = this.ff.httpsCallable('callCieloPIX');
    const result = callCieloPIX({'isTest': false, 'cardAuthorize': JSON.stringify(cardAuthorize)})
    return result

  }

  async callCieloPIXURI (link) {

    const callCieloPIXURI = this.ff.httpsCallable('callCieloPIXURI');
    const result = callCieloPIXURI({'isTest': true, 'link': link})
    console.log(JSON.stringify(result))
    return result
  }

  async captureCieloPIX (amount, link) {

    const captureCieloPIX = this.ff.httpsCallable('captureCieloPIX');
    const result = captureCieloPIX({'amount': amount, 'link': link})
    //console.log(JSON.stringify(result))
    return result

  }

  async capturePIX () {
    const capturePIX = this.ff.httpsCallable('capturePIX');
    const result = capturePIX({})
    //console.log(JSON.stringify(result))
    return result
  }

  /////////////////////////////////////////////////////////
  // versão para anuidades
  //
  async cieloPayment (payload: any): Promise<any> {
    //
    /////////////////////////////////
    const ENVIRONMENT = "PRODUÇÃO"; // ou SANDBOX 
    ///////////////////////////////////
    //
    const payloadData = {
      "environment": ENVIRONMENT,
      ...payload,
    }
    //
    // console.log(' >>>> payloadData:', JSON.stringify(payloadData));

    const URL_CREATE_PAYMENT = 'https://us-central1-sbccv-proj.cloudfunctions.net/cieloPayment';

    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      const response: any = await this._http.post(URL_CREATE_PAYMENT, payloadData, {headers}).toPromise();
      return response;
    } catch (error) {
      console.log('Erro em cieloPayment status:', error.status);
      console.log('Erro em cieloPayment message:', error.message);
      console.log(' >>>> Erro Cielo:', JSON.stringify(error.error));
      return error.status;
    }

  }


}
